import {
  Autocomplete,
  Box,
  FormControl,
  InputLabel,
  TextField,
} from "@mui/material";
import React from "react";

export default function FormikAutocomplete(props) {
  let { disabled, name, label, type, fieldValue, handleChange, options } =
    props;
  return (
    <Box className="appointment-dropdown">
      <InputLabel>{label}</InputLabel>
      <FormControl
        fullWidth
        sx={{
          borderRadius: "25px",
          background: "var(--secondary-white, #fff)",
        }}
      >
        <Autocomplete
          type={type}
          name={name}
          value={fieldValue.value}
          placeholder={label}
          onChange={handleChange}
          onBlur={fieldValue.onBlur}
          disablePortal
          fullWidth
          id="combo-box-demo"
          options={options}
          disabled={disabled}
          className="dropdown-select"
          freeSolo={false}
          isOptionEqualToValue={(option, value) => option.label === value}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={label}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
      </FormControl>
    </Box>
  );
}
